import React from 'react';
import Marketing from '../images/marketing.svg';
import { Link } from 'react-router-dom';
import { FaCloud, FaLock, FaMobileAlt, FaDesktop } from 'react-icons/fa';
import SubserviceDetailComponent from '../components/SubserviceDetailComponent';

const services = [
  {
    icon: <FaCloud />,
    title: 'Industry Trends',
    description: 'Stay ahead with comprehensive industry trend analysis. Understand market shifts and emerging opportunities to make informed strategic decisions for your business.',
  },
  {
    icon: <FaLock />,
    title: 'Consumer Insights',
    description: 'Gain valuable consumer insights to tailor your marketing strategies. Our analysis helps you understand customer behavior, preferences, and needs for targeted engagement.',
  },
  {
    icon: <FaMobileAlt />,
    title: 'Competitive Analysis',
    description: 'Benchmark your performance against competitors. Our competitive analysis identifies strengths and weaknesses, helping you craft strategies to gain a competitive edge.',
  },
  {
    icon: <FaDesktop />,
    title: 'Product Placement Analysis',
    description: 'Optimize product placement with in-depth analysis. Ensure your products are strategically positioned to maximize visibility and sales in the market.',
  },
  {
    icon: <FaDesktop />,
    title: 'Client Retention Strategy',
    description: 'Enhance client loyalty with effective retention strategies. We develop customized plans to keep your clients satisfied and engaged with your brand.',
  },
];

const MarketResearch = () => {
  return (
    <div className = "relative">
      <img
        className="h-auto w-full object-cover"
        src={Marketing}
        alt="Marketing Services"
      />

      <div>

      <section className='text-left mt-6'>
      <h1 className="text-center my-6 text-2xl font-semibold">Market Research & Analysis</h1>
      </section>
     

      <section>
        <SubserviceDetailComponent services={services}/>
        <div className='mb-6'>
        <h2 className="text-xl font-semibold mb-6 mx-6">Get Started with Expert Marketing Services</h2>
        <p className="text-md text-black mb-6 px-12 text-left">
        Maximize efficiency, enhance security, and drive growth with our tailored Marketing Services. Our certified experts provide 24/7 support, proactive monitoring, and strategic Marketing planning to meet your business needs.
        </p>
        
        <Link to="/contact"
        className="inline-block bg-[#13689b] text-white py-3 px-6 rounded-md text-md font-semibold transition-transform transform hover:scale-105">
      Contact Us
      </Link>
        </div>
      </section>

    </div>

    </div>
  )
}

export default MarketResearch
